import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes, faUser } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import classnames from "classnames";

import NavIcon from "./navIcon";
import authContext from "../contexts/auth/authContext";

const loginLink = { path: "/", label: "Login", icon: faUser, activePaths: [] };

const Header = ({ links, enableDuplicateStage }) => {
    // type will be missing for profiling and scheduling
    const { pathname } = useLocation();
    const [showMenu, setShowMenu] = useState(false);
    const { authenticated, initiateLogin, isAllowedRole, isAllowedPermission } = useContext(authContext);

    const onLogin = (e) => {
        e.preventDefault();
        initiateLogin();
    };

    const onMenuClick = (e) => {
        e.preventDefault();
        setShowMenu(!showMenu);
    };

    return (
        <header id="header">
            <div className="container">
                <nav className="main-nav">
                    <a
                        href="#menu"
                        className="btn-menu"
                        onClick={onMenuClick}
                    >
                        <FontAwesomeIcon icon={showMenu ? faTimes : faBars} />
                    </a>
                    <div className={classnames("menu-items", { "-active": showMenu })}>
                        {authenticated &&
                            links
                                .filter((link) => isAllowedRole(link.allowedRoles) && isAllowedPermission(link.allowedPermission))
                                .map((link) => (
                                    <NavIcon
                                        key={`navIcon_${link.label}`}
                                        data={link}
                                        currentPath={pathname}
                                        disableDuplicateStage={!enableDuplicateStage}
                                    />
                                ))}
                        {!authenticated && (
                            <NavIcon
                                key="navIcon_Login"
                                data={loginLink}
                                onClick={onLogin}
                            />
                        )}
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
